import React from "react";
import { useEffect, useState } from "react";

import { css } from "@emotion/core";
import { kebabCase } from "lodash";

import { Colors } from "@zapier/design-system";

import { breakpoints } from "@zapier/payment/esm/constants";
import buildStaticAssetUrl from "@zapier/payment/esm/utils/buildStaticAssetUrl";

const svgCss = (props: PaymentMethodImageProps) => ({
  display: "block",
  height: "inherit",
  opacity: props.isDisabled ? 0.4 : 1.0,
  width: "inherit",
  border: `1px solid ${Colors.neutral400}`,
  borderRadius: "4px",
});

/* Rebrand styles */
const imageCss = (props: { isSmall?: boolean }) => css`
  display: inline-block;
  width: ${props.isSmall ? "43px" : "63px"};

  @media screen and (max-width: ${breakpoints.mobileMax}px) {
    width: 43px;
  }
`;

type PaymentMethodImageProps = {
  /** Image type to show */
  imageType?: string | null;
  /** Show image greyed out */
  isDisabled?: boolean;
  /** Show small version of image */
  isSmall?: boolean;
};

const PaymentMethodImage = (props: PaymentMethodImageProps) => {
  const [imageNotFound, setImageNotFound] = useState(false);
  const { imageType } = props;

  // Sets the image not found flag back to false if imageType changes
  useEffect(() => {
    setImageNotFound(false);
  }, [imageType]);

  const svgUrl =
    !imageType || imageNotFound
      ? buildStaticAssetUrl("/images/payment/logos/unknown.svg")
      : buildStaticAssetUrl(
          `/images/payment/logos/${kebabCase(imageType)}.svg`
        );

  return (
    <span css={imageCss(props)}>
      <img
        alt={imageType ?? "Payment Method Image Placeholder"}
        css={svgCss(props)}
        onError={() => setImageNotFound(true)}
        src={svgUrl}
      />
    </span>
  );
};

export default PaymentMethodImage;
